import { action, observable, runInAction } from 'mobx';

import config from '../config';

export class AuthStore {
    username?: string;
    password?: string;
    @observable loading: boolean;

    async getAccessCode() {
        this.loading = true;
        const res = await fetch(config.API_ENDPOINT + '/identity/signin/', {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
            body: JSON.stringify({ username: this.username, password: this.password }),
        });

        const json = await res.json();
        runInAction(() => {
            this.loading = false;
        });

        if (!res.ok) {
            return Promise.reject(new Error(json));
        }

        localStorage.setItem('access_token', json.access_token);
        return Promise.resolve();
    }

    @action async logout() {
        this.username = undefined;
        this.password = undefined;
        this.loading = false;
        localStorage.removeItem('access_token');
    }
}

export default new AuthStore;



// WEBPACK FOOTER //
// ./src/stores/AuthStore.ts